
export const CreateManager = () => {
  return (
    <div>CreateManager</div>
  )
}
